$(function() {

    $.facts = {};

    $('.facts-section').each(function(i) {

        var id = $(this).attr('id');
        var section = '#'+ id;

        $.facts[id] = {};

        // durations

        $.facts[id].duration = '50%';

        $.facts[id].calculatePinDuration = function() {
            var contentHeight = $(section +' .facts').outerHeight();
            $.facts[id].pinDuration = Math.round(contentHeight + ($(window).innerHeight()));
            return $.facts[id].pinDuration;
    	};

        $.facts[id].endDuration = ($(section).next('section').hasClass('profile-section')) ? '50%' : '50%'; // check if profile follows

        // timelines

        $.facts[id].tl = {};

        // in

    	$.facts[id].tl.in = new TimelineMax();

        $.facts[id].tl.in.addLabel("start");

        $.facts[id].nextSectionID = $(section).next('section').attr('id');
        $.facts[id].tl.in.set("#"+ $.facts[id].nextSectionID, { visibility: "visible" }, "start");

        $.facts[id].tl.in.set(section, { visibility: "visible" }, "start");

        $.facts[id].tl.in.fromTo(section +' .facts', 1, { opacity:0 }, { opacity:1 }, "start");

        new ScrollMagic.Scene({ triggerElement: section +' .facts-start', triggerHook: 'onLeave', duration: $.facts[id].duration })
            .on('start', function () {
            })
            .setTween($.facts[id].tl.in)
        	// .addIndicators({name: id +' in'})
        	.addTo($.controller);

        $.facts[id].tl.out = new TimelineMax();

        $.facts[id].tl.out.addLabel("start");

        $.facts[id].tl.out.to(section +' .facts-background', 1, { opacity:0, delay:1 }, "start");
        $.facts[id].tl.out.to(section +' .facts', 1, { opacity:0, delay:1 }, "start");

        new ScrollMagic.Scene({ triggerElement: section +' .facts-end', triggerHook: 'onCenter', duration: $.facts[id].endDuration })
            .on('leave', function () {
            })
            .setTween($.facts[id].tl.out)
            // .addIndicators({name: in +' out'})
            .addTo($.controller);

    });

});
